module.exports = __webpack_public_path__ + "static/media/arrowDown.2bbbf7e5.svg";